import React, { useEffect, useState } from 'react';
import {
  Box,
  CircularProgress,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import { AnswerSummaryProps } from './types';
import { useAppDispatch } from '../../../app/hooks';
import { ScoreAnswer, ScoresToggleIsCorrectUpdateRequest } from '../../../generated/api';
import { fetchScoreAnswersAsync, toggleIsCorrectAsync } from './scoreSlice';
import { CloseRounded, DoneRounded } from '@mui/icons-material';

const AnswerSummary = ({ categoryId, attemptId }: AnswerSummaryProps) => {
  const dispatch = useAppDispatch();
  const [answers, setAnswers] = useState<ScoreAnswer[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    dispatch(fetchScoreAnswersAsync({ attemptId: attemptId.toString(), categoryId: categoryId.toString() }))
      .unwrap()
      .then((value) => {
        setAnswers(value);
        setLoading(false);
      });
  }, []);

  const toggleIsCorrect = async (questionId: number) => {
    const request: ScoresToggleIsCorrectUpdateRequest = {
      attemptId: attemptId.toString(),
      questionId: questionId.toString()
    };
    await dispatch(toggleIsCorrectAsync(request));
    setAnswers((prevState) =>
      prevState.map((answer) => (answer.id === questionId ? { ...answer, isCorrect: !answer.isCorrect } : answer))
    );
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }
  if (!answers.length) {
    return (
      <Typography align="center" paddingY={2}>
        No data
      </Typography>
    );
  }

  return (
    <Paper elevation={2} sx={{ margin: 1 }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Question</TableCell>
            <TableCell>Correct answer</TableCell>
            <TableCell>Given Answer</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {answers.map((answer) => {
            return (
              <TableRow key={answer.id}>
                <TableCell>{answer.question}</TableCell>
                <TableCell>{answer.correctAnswer}</TableCell>
                <TableCell>{answer.givenAnswer}</TableCell>
                <TableCell padding="none">
                  {answer.isCorrect !== null && (
                    <IconButton onClick={() => toggleIsCorrect(answer.id)}>
                      {answer.isCorrect ? <DoneRounded color="success" /> : <CloseRounded color="error" />}
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default AnswerSummary;
